import httpClient from "@/api/httpClient";
import ReviewPage from "@/model/ReviewPage";

function listForProperty(
  accessToken: string,
  propertyId: string,
  page: number,
  size: number
): Promise<ReviewPage> {
  return httpClient.getJson<ReviewPage>(
    `/api/properties/${propertyId}/reviews?page=${page}&size=${size}`,
    accessToken
  );
}

/** Admins only (moderation); hosts can't delete reviews of their own properties. */
function deleteReview(accessToken: string, id: string): Promise<void> {
  return httpClient.deleteNoContent(`/api/reviews/${id}`, accessToken);
}

const reviewsApi = {
  listForProperty,
  deleteReview,
};

export default reviewsApi;
